export default __webpack_public_path__ + "waves-hero.svg";